var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgReceiptx(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 256 256"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M216 40H40a16 16 0 00-16 16v152a8 8 0 0011.58 7.15L64 200.94l28.42 14.21a8 8 0 007.16 0L128 200.94l28.42 14.21a8 8 0 007.16 0L192 200.94l28.42 14.21A8 8 0 00232 208V56a16 16 0 00-16-16zm-58.34 98.34a8 8 0 01-11.32 11.32L128 131.31l-18.34 18.35a8 8 0 01-11.32-11.32L116.69 120l-18.35-18.34a8 8 0 0111.32-11.32L128 108.69l18.34-18.35a8 8 0 0111.32 11.32L139.31 120z"
  })));
}

export default SvgReceiptx;